import {DocumentNode, gql} from "@apollo/client";

export const UPDATE_SECRET_KEY_MUTATION: DocumentNode = gql(`
    mutation UpdateSecretKey($tfaCode: String) {
        updateSecretKey(tfaCode: $tfaCode) {
            secretKey
        }
    }
`);